import { render } from "./Agreement.vue?vue&type=template&id=4a8b09a3&scoped=true"
const script = {}

import "./Agreement.vue?vue&type=style&index=0&id=4a8b09a3&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8b09a3"]])

export default __exports__